module.exports = __webpack_public_path__ + "af662f660894a96319f9e7634f903c50.pdf";